export const sources={};export const img={src:"__VITE_ASSET___d$owdhm__",w:36,h:36};export default{sources:sources,img:img};